const MOBILE_BREAKPOINT = 768;

/**
 * Detect phone/tablet for RM scan UX.
 * Width alone fails when mobile Chrome uses "Desktop site" or a wide CSS viewport.
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || navigator.vendor || '';
  const uaMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|CriOS|FxiOS/i.test(
      ua,
    );

  // iPadOS 13+ often reports as MacIntel with touch points
  const iPadTouch = navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1;

  const coarsePointer =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: coarse)').matches &&
    window.innerWidth < 1024;

  const narrow = window.innerWidth < MOBILE_BREAKPOINT;

  return uaMobile || iPadTouch || coarsePointer || narrow;
}

export { MOBILE_BREAKPOINT };
